import {useTranslation} from "react-i18next";
import {TxtTitles} from "../../../../../../../../helpers/breadCrumbs";
import {ListInformationElement} from "./ListInformationElement";
import React from "react";

const MusCategories = ({categories_name}) => {
    const {t} = useTranslation()
    const fields = [
        {
            title: '',
            widthLimit: '3%'
        },
        {
            title: <TxtTitles>{categories_name}</TxtTitles>,
            widthLimit: '97%'
        }
    ];

    return <ListInformationElement fields={fields} style={{paddingBottom:'0px'}} />;
}

export default MusCategories;

